import { atom } from 'recoil'
import { TEMPLATE_TYPE_LOCAL } from 'Constants/index'
export const DEFAULT_SEARCH = {
  type: TEMPLATE_TYPE_LOCAL,
  searchText: '',
  pageNumber: 1,
  pageSize: 10
}

export const searchState = atom({
  key: 'templateListSearchState',
  default: DEFAULT_SEARCH
})
